export const getPositionOf = (element) => {
    if (!element) {
        return { x: 0, y: 0 };
    }
    const { left, bottom } = element.getBoundingClientRect();
    return { x: left, y: bottom + window.scrollY };
};
